import Route from 'cio/routes/base';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import SetupGuideController from 'cio/pods/setup-guide/controller';

export default class SetupGuideIndexRoute extends Route {
  @service auth!: AuthService;

  redirect() {
    if (this.auth.user?.isReadOnly ?? true) {
      return;
    }

    // We want to intercept and redirect to the last active setup guide route
    // if there is a last active step set on the setup guide controller.
    //
    // Otherwise, we just redirect to sources.
    let controller = this.controllerFor('setup-guide') as SetupGuideController;
    if (!controller.lastActiveSetupUpGuideStep) {
      return this.router.transitionTo('setup-guide.welcome');
    }

    if (controller.lastActiveSetupUpGuideStep === 'setup-guide.index') {
      return this.router.transitionTo('setup-guide.welcome');
    }

    return this.router.transitionTo(controller.lastActiveSetupUpGuideStep);
  }
}
